// eslint-disable-next-line import/prefer-default-export
export const baseUrl = 'https://store.steampowered.com/'
